/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */


import React, { useEffect, useRef, useState } from "react";

// react-github-btn

// @mui material components
import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Switch from "@mui/material/Switch";
// @mui icons

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Custom styles for the Configurator
import ConfiguratorRoot from "examples/Configurator/ConfiguratorRoot";
// Material Dashboard 2 React context
import axios from "axios";
import {
  setDarkMode,
  setFixedNavbar,
  setOpenConfigurator,
  setSidenavColor,
  setTransparentSidenav,
  setWhiteSidenav,
  useMaterialUIController,
} from "context";





let useClickOutside = (handler) => {
  let domeNode = useRef();

  useEffect(() => {
    let maybeHandler = (e) => {
      if (!domeNode.current.contains(e.target)) {
        handler()
      }
    }
    document.addEventListener("mousedown", maybeHandler);
    return () => {
      document.removeEventListener('mousedown', maybeHandler)
    };
  });

  return domeNode;
}

function Configurator() {
  const [controller, dispatch] = useMaterialUIController();
  const {
    openConfigurator,
    fixedNavbar,
    sidenavColor,
    transparentSidenav,
    whiteSidenav,
    darkMode,
  } = controller;
  const [disabled, setDisabled] = useState(false);
  const sidenavColors = ["primary", "dark", "info", "success", "warning", "error"];

  let menuRef = useClickOutside(() => {
    setOpenConfigurator(dispatch, false)
  })
  //Theme Color UseState
  const [themeView, setThemeView] = useState(false);
   const [isNavbarFixed, setIsNavbarFixed] = useState(false);
  useEffect(() => {
    const storedTheme = sessionStorage.getItem('THEME_DARK');
    if (storedTheme !== undefined && storedTheme !== null) {
      const isDark = storedTheme === 'true'; // Convert to boolean
      setThemeView(isDark);
      setDarkMode(dispatch, isDark);
    }
    let changeColor = sessionStorage.getItem("THEME_COLOR")
    if(changeColor){
      setSidenavColor(dispatch, changeColor)
    }   
    let themeType = sessionStorage.getItem("THEME_TYPE")

    if(themeType == "Dark"){
      setWhiteSidenav(dispatch, false);
      setTransparentSidenav(dispatch, false);
    } else if(themeType == "Transparent"){
      setTransparentSidenav(dispatch, true);
    setWhiteSidenav(dispatch, false);
    } else if(themeType == "White"){
      setWhiteSidenav(dispatch, true);
    setTransparentSidenav(dispatch, false);
    }

    
  }, []);

  useEffect(() => {
 
    const storedFixedNavbar = sessionStorage.getItem("FIXED_NAVBAR");
    if (storedFixedNavbar !== null) {
      const isFixed = storedFixedNavbar === "true";
      setIsNavbarFixed(isFixed);
      setFixedNavbar(dispatch, isFixed);
    }
  }, [dispatch]);
  



  const themeChange = async (event) => {
    const isDark = event.target.checked;
    setThemeView(isDark);
    setDarkMode(dispatch, isDark);
    sessionStorage.setItem('THEME_DARK', isDark);
  };

  // Use the useEffect hook to change the button state for the sidenav type based on window size.
  useEffect(() => {
    // A function that sets the disabled state of the buttons for the sidenav type.
    function handleDisabled() {
      return window.innerWidth > 1200 ? setDisabled(false) : setDisabled(true);
    }

    // The event listener that's calling the handleDisabled function when resizing the window.
    window.addEventListener("resize", handleDisabled);

    // Call the handleDisabled function to set the state with the initial value.
    handleDisabled();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleDisabled);
  }, []);
  const handleCloseConfigurator = () => setOpenConfigurator(dispatch, false);
  const handleTransparentSidenav = () => { 
    sessionStorage.setItem("THEME_TYPE","Transparent")
    setTransparentSidenav(dispatch, true);
    setWhiteSidenav(dispatch, false);
  };
  const handleWhiteSidenav = () => {
    sessionStorage.setItem("THEME_TYPE","White")
    setWhiteSidenav(dispatch, true);
    setTransparentSidenav(dispatch, false);
  };
  const handleDarkSidenav = () => {
    sessionStorage.setItem("THEME_TYPE","Dark")
    setWhiteSidenav(dispatch, false);
    setTransparentSidenav(dispatch, false);
  };

  const handleFixedNavbar = (event) => {
    const isFixed = event.target.checked;
    setIsNavbarFixed(isFixed);
    setFixedNavbar(dispatch, isFixed);
    sessionStorage.setItem("FIXED_NAVBAR", isFixed);
  };
  // const handleFixedNavbar = () => setFixedNavbar(dispatch, !fixedNavbar);
  // sidenav type buttons styles
  const sidenavTypeButtonsStyles = ({
    functions: { pxToRem },
    palette: { white, dark, background },
    borders: { borderWidth },
  }) => ({
    height: pxToRem(39),
    background: darkMode ? background.sidenav : white.main,
    color: darkMode ? white.main : dark.main,
    border: `${borderWidth[1]} solid ${darkMode ? white.main : dark.main}`,

    "&:hover, &:focus, &:focus:not(:hover)": {
      background: darkMode ? background.sidenav : white.main,
      color: darkMode ? white.main : dark.main,
      border: `${borderWidth[1]} solid ${darkMode ? white.main : dark.main}`,
    },
  });
  // sidenav type active button styles
  const sidenavTypeActiveButtonStyles = ({
    functions: { pxToRem, linearGradient },
    palette: { white, gradients, background },
  }) => ({
    height: pxToRem(39),
    background: darkMode ? white.main : linearGradient(gradients.dark.main, gradients.dark.state),
    color: darkMode ? background.sidenav : white.main,

    "&:hover, &:focus, &:focus:not(:hover)": {
      background: darkMode ? white.main : linearGradient(gradients.dark.main, gradients.dark.state),
      color: darkMode ? background.sidenav : white.main,
    },
  });

   const handleThemeColor=((color)=>{
    
    sessionStorage.setItem("THEME_COLOR",color)
    setSidenavColor(dispatch, color)
    
   })
  //  useEffect(()=>{
  //   let changeColor = sessionStorage.getItem("THEME_COLOR")
  //   if(changeColor){
  //     setSidenavColor(dispatch, changeColor)
  //   }    
  //  },[])

  //  let data = sessionStorage.getItem("Name:")
 
   
   
   
  return (
    <div ref={menuRef}>
      <ConfiguratorRoot variant="permanent" ownerState={{ openConfigurator }} >

        <MDBox
          display="flex"
          justifyContent="space-between"
          alignItems="baseline"
          pt={4}
          pb={0.5}
          px={3}
        >

          <MDBox>
            <MDTypography variant="h5">Theme Settings </MDTypography>
            {/* <MDTypography variant="body2" color="text">
            See our dashboard options.
          </MDTypography> */}
          </MDBox>

          <Icon
            sx={({ typography: { size }, palette: { dark, white } }) => ({
              fontSize: `${size.lg} !important`,
              color: darkMode ? white.main : dark.main,
              stroke: "currentColor",
              strokeWidth: "2px",
              cursor: "pointer",
              transform: "translateY(5px)",
            })}
            onClick={handleCloseConfigurator}
          >
            close
          </Icon>
        </MDBox>

        <Divider />

        <MDBox pt={0.5} pb={3} px={3}>
          <MDBox>
            <MDTypography variant="h6"> Theme Colour</MDTypography>

            <MDBox mb={0.5}>
              {sidenavColors.map((color) => (
                <IconButton
                  key={color}
                  sx={({
                    borders: { borderWidth },
                    palette: { white, dark, background },
                    transitions,
                  }) => ({
                    width: "24px",
                    height: "24px",
                    padding: 0,
                    border: `${borderWidth[1]} solid ${darkMode ? background.sidenav : white.main}`,
                    borderColor: () => {
                      let borderColorValue = sidenavColor === color && dark.main;

                      if (darkMode && sidenavColor === color) {
                        borderColorValue = white.main;
                      }

                      return borderColorValue;
                    },
                    transition: transitions.create("border-color", {
                      easing: transitions.easing.sharp,
                      duration: transitions.duration.shorter,
                    }),
                    backgroundImage: ({ functions: { linearGradient }, palette: { gradients } }) =>
                      linearGradient(gradients[color].main, gradients[color].state),

                    "&:not(:last-child)": {
                      mr: 1,
                    },

                    "&:hover, &:focus, &:active": {
                      borderColor: darkMode ? white.main : dark.main,
                    },
                  })}
                  
                  onClick={()=>handleThemeColor(color)}

                  // onClick={()=>sessionStorage.setItem("Name:",color)}
                  // onClick={() => setSidenavColor(dispatch, color)}
                />
              ))}
            </MDBox>
          </MDBox>

          <MDBox mt={3} lineHeight={1}>
            <MDTypography variant="h6">Theme Type</MDTypography>
            {/* <MDTypography variant="button" color="text">
            Choose between different sidenav types.
          </MDTypography> */}

            <MDBox
              sx={{
                display: "flex",
                mt: 2,
                mr: 1,
              }}
            >
              <MDButton
                color="dark"
                variant="gradient"
                onClick={handleDarkSidenav}
                disabled={disabled}
                fullWidth
                sx={
                  !transparentSidenav && !whiteSidenav
                    ? sidenavTypeActiveButtonStyles
                    : sidenavTypeButtonsStyles
                }
              >
                Dark
              </MDButton>
              <MDBox sx={{ mx: 1, width: "8rem", minWidth: "8rem" }}>
                <MDButton
                  color="dark"
                  variant="gradient"
                  onClick={handleTransparentSidenav}
                  disabled={disabled}
                  fullWidth
                  sx={
                    transparentSidenav && !whiteSidenav
                      ? sidenavTypeActiveButtonStyles
                      : sidenavTypeButtonsStyles
                  }
                >
                  Transparent
                </MDButton>
              </MDBox>
              <MDButton
                color="dark"
                variant="gradient"
                onClick={handleWhiteSidenav}
                disabled={disabled}
                fullWidth
                sx={
                  whiteSidenav && !transparentSidenav
                    ? sidenavTypeActiveButtonStyles
                    : sidenavTypeButtonsStyles
                }
              >
                White
              </MDButton>
            </MDBox>
          </MDBox>
          <MDBox
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mt={3}
            lineHeight={1}
          >
            <MDTypography variant="h6">Top Bar Fixed</MDTypography>

            <Switch checked={fixedNavbar} onChange={handleFixedNavbar} />
          </MDBox>
          <Divider />
          <MDBox display="flex" justifyContent="space-between" alignItems="center" lineHeight={1}>
            <MDTypography variant="h6">Light / Dark</MDTypography>

            <Switch checked={themeView} onChange={themeChange}
            />
          </MDBox>
          <Divider />

          {/* <BillingModal
            open={showThemePopup}
            handleConfirm={() => { setShowThemePopup(false); sessionStorage.setItem('ShowThemeDialog', false) }}
            handleCancel={handleThemeChange}
            closeModalClick={() => { setShowThemePopup(false) }}
            message=""
            title={`Do you want to Continue with same Theme?`}
          /> */}
        </MDBox>

      </ConfiguratorRoot>
    </div>

  );
}

export default Configurator;
